import { Link } from "react-router-dom";

type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-3 md:px-6">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500 md:text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
                {index > 0 ? (
                  <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
                ) : null}
                {item.to && !isLast ? (
                  <Link to={item.to} className="transition-colors hover:text-primary-700">
                    {item.label}
                  </Link>
                ) : (
                  <span aria-current={isLast ? "page" : undefined} className="text-foreground-800">
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}